export const reviews = (Swiper)=> {

    let swiper = null;

    function initSwiper() {
       swiper = new Swiper('.reviews__swiper', {
            spaceBetween: 10,
            slidesPerView: 1.11,
            scrollbar: {
                el: '.reviews__swiper-scrollbar',
            },
           breakpoints: {
               640: {
                   slidesPerView: 1.5,
               },
               768: {
                   slidesPerView: 2,
               }
           }
        });
    }

    function checkWindowSize() {
        if (window.innerWidth > 1024) {
            if (swiper !== null) {
                swiper.destroy(true, true);
                swiper = null;
            }
        } else {
            if (swiper === null) {
                initSwiper();
            }
        }
    }

    checkWindowSize();

    window.addEventListener('resize', checkWindowSize);
}